@if (href) {
  <a
    [href]="href"
    [attr.target]="target"
    [attr.rel]="hostRel"
    [attr.aria-label]="ariaLabel || null"
    [ngClass]="classes"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <button
    [ngClass]="classes"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || null"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}

<ng-template #content>
  <!-- Standard and Ghost Variants -->
  @if (variant === 'standard' || variant === 'ghost') {
    <!-- Custom Image or Icon Position -->
    @if (customImage) {
      <span class="btn-image-wrapper">
        <img [src]="customImage" alt="" class="btn-image" />
      </span>
    } @else {
      @if (icon) {
        <span class="btn-icon-wrapper">
          <hyperkit-icon
            [icon]="icon!"
            [size]="'small'"
            [color]="resolvedIconColor"
          ></hyperkit-icon>
        </span>
      }
    }
    <!-- Button Text -->
    @if (text) {
      <span class="btn-text">
        <hyperkit-typography variant="emphasized" [size]="textSize" [color]="'inherit'">
          {{ text }}
        </hyperkit-typography>
      </span>
    }
  }

  <!-- Icon Variant -->
  @if (variant === 'icon') {
    <span class="btn-icon-wrapper">
      <hyperkit-icon
        [icon]="icon!"
        [size]="'small'"
        [color]="resolvedIconColor"
      ></hyperkit-icon>
    </span>
  }

  <!-- Link Variant -->
  @if (variant === 'link') {
    @if (text) {
      <span class="btn-text">
        <hyperkit-typography variant="emphasized" [size]="textSize" [color]="'inherit'">
          {{ text }}
        </hyperkit-typography>
      </span>
    }
  }

  <!-- Collapsable Variant -->
  @if (variant === 'collapsable') {
    @if (text) {
      <span class="btn-text">
        <hyperkit-typography variant="emphasized" [size]="textSize" [color]="'inherit'">
          {{ text }}
        </hyperkit-typography>
      </span>
    }
    <span class="btn-icon-wrapper">
      <hyperkit-icon
        [icon]="icon!"
        [size]="'medium'"
        [color]="resolvedIconColor"
        [ngClass]="{ expanded: isExpanded }"
      ></hyperkit-icon>
    </span>
  }
</ng-template>
